import React from 'react';
import TicketList from '../TicketListComponents/TicketList';
import { useAuth } from '../../auth/AuthHandler';

function Home() {
  const { userRoles } = useAuth();

  const isUserRoleOnly = userRoles.length === 0 || (userRoles.length === 1 && userRoles.includes("USER"));

  return (
    <div>
      {isUserRoleOnly ? (
        <p>Contact admin to provide additional permission - role.</p>
      ) : (
        <TicketList />
      )}
    </div>
  );
};

export default Home;
